<div class="nav-item" [ngClass]="{ 'nav-caption': item.navCap }">
  
  <!-- Parent items (group headers) - static without chevron -->
  <ng-container *ngIf="item.navCap && !isCollapsed">
    <div class="nav-caption">
      <div class="nav-caption-left">
        <!-- <i-tabler 
          *ngIf="item.parentIcon"
          class="parent-icon" 
          [name]="item.parentIcon"
          matListItemIcon>
        </i-tabler> -->
        <span>{{ item.navCap }}</span>
      </div>
    </div>

    <!-- Children always visible, no expand/collapse -->
    <div class="nav-children">
      <app-nav-item
        *ngFor="let child of item.children"
        [item]="child"
        [depth]="depth + 1"
        [isCollapsed]="isCollapsed"
      ></app-nav-item>
    </div>
  </ng-container>

  <!-- In collapsed mode, show parent as icon only -->
  <a
    *ngIf="item.navCap && isCollapsed"
    mat-list-item
    (click)="onParentIconClick(item)"
    class="menu-list-item primary collapsed-parent"
    [class.active-parent]="hasActiveChild()"
  >
    <i-tabler
      class="routeIcon"
      [name]="item.parentIcon || 'folder'"
      matListItemIcon
      [matTooltip]="item.navCap"
      matTooltipPosition="right"
    ></i-tabler>
  </a>

  <!-- Regular menu items (leaf nodes) -->
  <ng-container *ngIf="!item.navCap">
    <a
      mat-list-item
      (click)="onItemSelected(item)"
      [class.activeMenu]="isItemActive(item)"
      class="menu-list-item primary"
      [class.icon-only]="isCollapsed"
    >
      <i-tabler
        *ngIf="item.iconName"
        class="routeIcon"
        [name]="item.iconName"
        matListItemIcon
        [matTooltip]="isCollapsed ? item.displayName : ''"
        matTooltipPosition="right"
      ></i-tabler>
      <span class="hide-menu" *ngIf="!isCollapsed">{{ item.displayName }}</span>
    </a>
  </ng-container>
</div>